import { render } from "./LaporanKegunaanTanah.vue?vue&type=template&id=1de11516"
import script from "./LaporanKegunaanTanah.vue?vue&type=script&lang=js"
export * from "./LaporanKegunaanTanah.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__